var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.icon)?_c('svg',{class:'pkc-icon_' + _vm.icon,attrs:{"width":_vm.width,"height":_vm.height}},[_c('use',{attrs:{"xlink:href":_vm.icon}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }